exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.change-date[data-v-75442b00] {\n    background-color: #c2282d;\n    color: white;\n    margin-top: 2em;\n    padding: 2.5em 1em;\n}\nbutton.close[data-v-75442b00] {\n    margin-top: -1em;\n    color: #fff;\n    opacity: 1;\n}\n", ""]);
